import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ProductSection() {
  const tomos = [{
    emoji: '📘',
    title: 'Volumen 1 — El Despertar Gástrico',
    items: ['Entendés por qué el omeprazol apaga el síntoma pero agrava la causa', 'Descubrís qué está pasando realmente en tu mucosa gástrica', 'Identificás tu nivel de daño sin estudios caros', 'Conectás acidez, cansancio y digestión en un solo mapa', 'Arrancás con claridad total desde el Día 1'],
    color: 'border-blue-500/30'
  }, {
    emoji: '📗',
    title: 'Volumen 2 — El Código de la Mucosa',
    items: ['Descubrís qué alimentos reconstruyen tu pared gástrica desde adentro', 'Sabés exactamente qué comer y qué evitar sin adivinar', 'Usás ingredientes de cualquier verdulería o super argentino', 'Reducís la inflamación sin pasar hambre', 'Empezás hoy, sin preparación previa'],
    color: 'border-green-500/30'
  }, {
    emoji: '📙',
    title: 'Volumen 3 — Exterminio Silencioso',
    items: ['Entendés por qué muchos tratamientos fallan por una causa oculta', 'Aplicás un cronograma de 15 días con hierbas argentinas accesibles', 'Eliminás el Bio-Film que protege las bacterias de cualquier tratamiento', 'Notás cambios en tu energía desde la primera semana', 'Avanzás fase por fase sin confundirte'],
    color: 'border-orange-500/30'
  }, {
    emoji: '📕',
    title: 'Volumen 4 — Operación Libertad',
    items: ['Reducís el omeprazol sin el efecto rebote que tanto te asusta', 'Seguís una escala de descenso diseñada para tu cuerpo', 'Reactivás tu producción natural de ácido gástrico', 'Recuperás la función digestiva que los antiácidos desactivaron', 'Salís del ciclo de dependencia química con un plan claro'],
    color: 'border-red-500/30'
  }, {
    emoji: '📒',
    title: 'Volumen 5 — Vida Plena',
    items: ['Volvés a disfrutar el asado, el mate y las reuniones sin pastillas de rescate', 'Tenés un plan de mantenimiento para no volver a empezar de cero', 'Detectás señales de recaída antes de que se conviertan en crisis', 'Usás recetas adaptadas a la cocina argentina sin irritantes', 'Vivís con un estómago fuerte y estable sin depender de nada externo'],
    color: 'border-yellow-500/30'
  }];
  const includes = ['Plan diario listo para arrancar hoy', 'Cronograma de limpieza de Bio-Film', 'Guía de transición del omeprazol', 'Checklist imprimible por etapa'];
  return <section className="py-24 bg-brand-dark" data-id="element-202">
      <div className="container mx-auto px-4" data-id="element-203">
        <div className="max-w-5xl mx-auto" data-id="element-204">
          <div className="text-center mb-16" data-id="element-205">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-206">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 text-brand-gold font-[Poppins,_sans-serif]" data-id="element-207">
                🏆 SISTEMA DIGESTIÓN SUPERIOR™
              </h2>
              <p className="text-2xl text-white font-medium mb-2" data-id="element-208">
                Tu hoja de ruta completa en 5 volúmenes para regenerar tu
                mucosa, recuperar tu energía y volver a comer sin miedo.
              </p>
            </motion.div>
          </div>

          <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-209">
            📚 5 VOLÚMENES COMPLETOS
          </h3>

          <div className="grid gap-6 mb-16" data-id="element-210">
            {tomos.map((tomo, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`bg-brand-black p-6 md:p-8 rounded-2xl border ${tomo.color} flex flex-col md:flex-row gap-6 items-start hover:bg-gray-900/50 transition-colors`} data-id="element-211">
                <div className="text-5xl shrink-0" data-id="element-212">{tomo.emoji}</div>
                <div data-id="element-213">
                  <h4 className="text-xl font-bold text-white mb-3" data-id="element-214">
                    {tomo.title}
                  </h4>
                  <ul className="space-y-2" data-id="element-215">
                    {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300" data-id="element-216">
                        <CheckCircle2 className="w-5 h-5 text-brand-light shrink-0 mt-0.5" data-id="element-217" />
                        <span data-id="element-218">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-green/10 border border-brand-green/30 rounded-2xl p-8 md:p-10" data-id="element-219">
            <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-220">
              El Sistema incluye:
            </h4>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-221">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-222">
                  <CheckCircle2 className="w-6 h-6 text-brand-light shrink-0" data-id="element-223" />
                  <span className="text-gray-200" data-id="element-224">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}